const columns = [
  { icon: '/images/smartTvAdvertising/icons/ctv.svg', label: 'CTV գովազդ' },
  { icon: '/images/smartTvAdvertising/icons/traditional-tv.svg', label: 'Ավանդական TV' },
  { icon: '/images/smartTvAdvertising/icons/video-ads.svg', label: 'Վիդեոգովազդ' },
];

const rows = [
  {
    label: 'Նպատակ',
    values: [
      'Բարձրացնել բրենդի ճանաչելիությունը TV միջավայրում՝ միաժամանակ օգտագործելով թվային թիրախավորման և չափելիության հնարավորությունները',
      'Ապահովել լայնածավալ բրենդային տեսանելիություն և զանգվածային իրազեկում',
      'Ստանալ ավելի արագ ներգրավվածություն, տրաֆիկ, դիտումներ, քլիքներ կամ կոնվերսիաներ՝ կախված արշավի նպատակից',
    ],
  },
  {
    label: 'Թիրախավորում',
    values: [
      'Ըստ դեմոգրաֆիայի, աշխարհագրական տարածքի, հետաքրքրությունների և ալիքների',
      'Ըստ ալիքի և ժամի թիրախավորում',
      'Ըստ դեմոգրաֆիայի, աշխարհագրական տարածքի, հետաքրքրությունների և վարքագծի',
    ],
  },
  {
    label: 'Վերաթիրախավորում',
    values: ['Հնարավոր է', 'Հնարավոր չէ', 'Հնարավոր է'],
  },
  {
    label: 'Չափելիություն',
    values: [
      'Հնարավոր է չափել դիտումները, հասանելիությունը, հաճախականությունը, completion rate-ը և որոշ դեպքերում՝ կայքի այցելությունները',
      'Չափելիությունը սահմանափակ է և հիմնականում հիմնվում է ընդհանուր վարկանիշների վրա',
      'Քլիքներ, դիտումներ, կոնվերսիաներ, ներգրավվածություն և այլ կարևոր ցուցանիշներ',
    ],
  },
  {
    label: 'Ճկունություն',
    values: [
      'Արշավի ընթացքում հնարավոր է արագ փոխել բյուջեն, լսարանը կամ կրեատիվը',
      'Փոփոխությունները հաճախ ավելի դանդաղ և բարդ են, երբեմն՝ անհնար',
      'Շատ ճկուն է՝ արագ թեստերի, A/B թեստավորման և օպտիմիզացիայի համար',
    ],
  },
  {
    label: 'Բյուջեի վերահսկում',
    values: [
      'Թույլ է տալիս ավելի արդյունավետ վերահսկել ծախսերը և ցուցադրումների հաճախականությունը',
      'Սովորաբար պահանջում է ավելի մեծ բյուջե և նախապես ֆիքսված բաշվածք',
      'Բյուջեն հեշտ է վերահսկել և օպտիմիզացնել ըստ արդյունքների',
    ],
  },
  {
    label: 'Գովազդի ընկալում',
    values: [
      'Ավելի մոտ է TV փորձառությանը, բայց ունի թվայինի առավելությունները',
      'Ընկալվում է որպես դասական հեռուստագովազդ',
      'Ավելի հաճախ դիտվում է mobile կամ desktop միջավայրում, ընկալումը ավելի նեգատիվ է, քան CTV-ների դեպքում',
    ],
  },
];

const Comparison = () => {
  return (
    <div className="bg-white">
      <div className="container py-[48px] md:py-[80px]">
        <h2 className="text-center font-[500] text-[28px] md:text-[36px] leading-[36px] md:leading-[44px] mb-[32px] md:mb-[48px] max-w-[650px] mx-auto">
          CTV vs Ավանդական TV vs Վիդեոգովազդ համացանցում
        </h2>
        <div className="hide_scrollbar overflow-x-auto">
          <div className="min-w-[900px] md:min-w-0">
            <div className="flex border-b border-[#89898933]">
              <div style={{ position: 'sticky', left: 0 }} className="z-10 bg-white w-[190px] shrink-0" />
              {columns.map(col => (
                <div key={col.label} className="w-[240px] md:flex-1 shrink-0 py-[16px] px-[16px]">
                  <div className="flex items-center gap-[8px] font-[500] text-[14px] text-[#414141]">
                    <img src={col.icon} alt="" className="w-[32px] h-[32px]" />
                    {col.label}
                  </div>
                </div>
              ))}
            </div>

            {rows.map(row => (
              <div key={row.label} className="flex border-b border-[#d5d5d5]">
                <div
                  style={{ position: 'sticky', left: 0 }}
                  className="flex items-center justify-center text-center uppercase z-10 bg-[#EDF2EB] text-[#3F463E] w-[190px] shrink-0 font-[400] text-[12px] py-[20px] px-[16px]"
                >
                  {row.label}
                </div>
                {row.values.map((value, i) => (
                  <div key={i} className="w-[240px] md:flex-1 shrink-0 text-[12px] leading-[18px] text-[#414141] py-[16px] px-[12px] tracking-wide">
                    {value}
                  </div>
                ))}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Comparison;
